export default __webpack_public_path__ + "static/media/Cardo.781eecc1.woff2";